interface MainContainerProps {
  children: JSX.Element;
}

export function MainContainer({ children }: MainContainerProps) {
  return (
    <div className="w-full h-full min-h-screen bg-white">
      <div className=" h-full mx-auto py-10 bg-white">{children}</div>
    </div>
  );
}
